import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './components/App';
import { Provider } from 'mobx-react';
import registerServiceWorker from './registerServiceWorker';
import store from './stores';

ReactDOM.render(
<Provider { ...store }>
    <App />
</Provider>,

document.getElementById('root')
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js